'use client';

import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { useEffect } from 'react';

import { attemptChunkLoadRecovery } from '@/utils/chunkLoadRecovery';

const GlobalError = ({ error }) => {
  useEffect(() => {
    // Same recovery as the route-level boundary — see src/app/error.js.
    if (attemptChunkLoadRecovery(error, { origin: 'global' })) {
      return;
    }

    Sentry.captureException(error, { tags: { errorBoundary: 'global' } });
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
};

export default GlobalError;
